// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/thunderstorm-avoidance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/thunderstorm-avoidance/thunderstorm-avoidance.js';

mount([g0]);
